import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
// import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import 'moment/locale/es'
import moment from 'moment'

moment.locale('es')

const App = () => {
  return (
    <Suspense fallback={<div />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            {/* <AuthInit> */}
            <Outlet />
            <MasterInit />
            {/* </AuthInit> */}
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
